/**
 * Logger minimaliste conditionnel.
 *
 * - En dev (NODE_ENV !== 'production') : logs affichés normalement.
 * - En prod : debug() et info() deviennent des no-op.
 * - warn() et error() sont toujours actifs (utiles pour le suivi en prod).
 *
 * Usage :
 *   import { logger } from '../utils/logger';
 *   logger.debug('Connecting to WebSocket:', wsUrl);
 */

const IS_DEV = process.env.NODE_ENV !== 'production';
const noop = () => {};

export const logger = {
  debug: IS_DEV ? console.log.bind(console) : noop,
  info:  IS_DEV ? console.info.bind(console) : noop,
  warn:  console.warn.bind(console),
  error: console.error.bind(console),
};

export default logger;
